module.exports = __webpack_public_path__ + "img/left-arrow.ae3c90b3.svg";